import React, { useEffect, useState } from 'react';
import { Button, Input, Table } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ItemTypeahead, ServiceThreadSpinner } from '.';
import { DesktopContainer } from '../layouts';
import { api, constants, filterHelpers } from '../utils';

export default function CountNew() {
   const ALL_SITES = { value: "", label: "-- Select --" };
   const ALL_TYPES = { value: 0, label: "-- Select --" };
   const item = "";
   const navigate = useNavigate();
   const [data, setData] = useState([]);
   const [filters, setFilters] = useState([
      { filterName: "siteId", value: ALL_SITES },
      { filterName: "typeId", value: ALL_TYPES }
   ]);
   const [itemWithDesc, setDisplayItem] = useState("");
   const [loaded, setLoaded] = useState(false);
   const [sites, setSites] = useState([]);
   const [types, setTypes] = useState([]);
   const sleep = ms => new Promise(r => setTimeout(r, ms));

   useEffect(() => {
      api
         .fetch(`Mobile/InitNewCount`)
         .then(response => {
            if (response.data.success) {
               setData(response.data.model);
               //setEditor(response.data.canEdit);
               const siteList = _.concat([ALL_SITES],
                  _.map(response.data.sites, m => ({ value: m.id, label: m.text })));
               const typeList = _.concat([ALL_TYPES],
                  _.map(response.data.types, m => ({ value: m.id, label: m.name })));
               return { siteList: siteList, typeList: typeList };
            }
            else {
               toast.error(response.data.message);
            }
         }).then(async ({ siteList, typeList }) => {
            setSites(siteList);
            setTypes(typeList);
         })
         .catch((error) => {
            api.catchHandler(error);
         })
         .finally(() => {
            setLoaded(true);
         })
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   function handleTypeahead(opt) {
      let changes = Object.assign({}, data);
      if (_.isNil(opt)) {
         changes["countItem"] = "";
         setDisplayItem("");
      } else {
         changes["countItem"] = opt.itemNumber;
         setDisplayItem(opt.itemWithDesc);
      }
      setData(changes);
   }

   function onChange(field, value) {
      let changes = Object.assign({}, data);
      changes[field] = value;
      setData(changes);
   }

   function onSiteChange(newFilterValue) {
      const site = _.find(sites, x => x.value === newFilterValue.value);
      let newFilters = filterHelpers.getFilters(filters, ({ filterName: "siteId", value: site }));
      setFilters(newFilters);
      onChange("siteId", newFilterValue.value);
   }

   function onTypeChange(newFilterValue) {
      const type = _.find(types, x => x.value === newFilterValue.value);
      let newFilters = filterHelpers.getFilters(filters, ({ filterName: "typeId", value: type }));
      setFilters(newFilters);
      onChange("typeId", newFilterValue.value);
   }

   function save() {
      let warnings = [];
      if (!data.siteId || data.siteId === "") {
         warnings.push('Site is required\n');
      }
      if (!data.typeId || data.typeId < 1) {
         warnings.push('Type is required\n');
      }
      if (data.itemCount && !data.countItem) {
         warnings.push('Item is required\n');
      }
      if (warnings.length) {
         toast.error(warnings.join(''));
         return;
      }

      api
         .post(`Mobile/CreateCount`, data)
         .then(response => {
            if (response.data.success) {
               toast.success(`New count was created successfully!`);
               navigate(constants.ENDPOINTS.countSearch);
            }
            else {
               toast.error(response.data.message);
            }
         })
         .catch(api.catchHandler);
   }

   async function toggleCount() {
      let doFocus = data.itemCount;
      let changes = Object.assign({}, data);
      if (data.itemCount) {
         //This means they are removing the check
         setDisplayItem("");
         changes["countItem"] = "";
      }
      changes["itemCount"] = !data.itemCount;
      setData(changes);

      if (doFocus === true) {
         sleep(50);
         const itm = document.querySelector(`input[name=itemInput]`);
         if (itm !== null) {
            await itm.focus();
         }
      }
   }

   return (
      <>
         <DesktopContainer screenName="Inventory Counts">
            <ServiceThreadSpinner on={!loaded}>
               {loaded && data ?
                  <div>
                     <Table borderless size="sm">
                        <tbody>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <label className="h6 fw-bold mx-1 my-0">Inventory Site:</label>
                              </td>
                           </tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <FilterSelect
                                    filterName="siteId"
                                    options={sites}
                                    value={filterHelpers.getValue(filters, "siteId")}
                                    onChangeCallback={e => onSiteChange(e)}
                                 />
                              </td>
                           </tr>

                           <tr><td className="data-cell m-0 p-0">&nbsp;</td></tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <label className="h6 fw-bold mx-1 my-0">Inventory Type:</label>
                              </td>
                           </tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <FilterSelect
                                    filterName="typeId"
                                    options={types}
                                    value={filterHelpers.getValue(filters, "typeId")}
                                    onChangeCallback={e => onTypeChange(e)}
                                 />
                              </td>
                           </tr>

                           <tr><td className="data-cell  p-0">&nbsp;</td></tr>
                           <tr>
                              <td className="data-cell py-0">
                                 <label className="h6 fw-bold">
                                    <Input
                                       name="singleCount"
                                       type="checkbox"
                                       className="mx-2 my-0"
                                       checked={(data && data.itemCount)}
                                       onChange={() => toggleCount()}
                                    /> Single Item Count?
                                 </label>
                              </td>
                           </tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <label className="h6 fw-bold mx-1 my-0">{itemWithDesc}</label>
                              </td>
                           </tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <ItemTypeahead
                                    name="itemInput"
                                    value={item}
                                    onChange={(e) => handleTypeahead(e)}
                                 />
                              </td>
                           </tr>

                           <tr><td className="data-cell m-0 p-0 lineheight8">&nbsp;</td></tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <Button
                                    title="save"
                                    className="shredButton w-100 btn-md my-0"
                                    onClick={() => { save(); }}>
                                    OK
                                 </Button>
                              </td>
                           </tr>
                           <tr><td className="data-cell m-0 p-0 lineheight8">&nbsp;</td></tr>
                           <tr>
                              <td className="data-cell my-0 py-0">
                                 <Button
                                    title="save"
                                    className="btn w-100 btn-md my-0"
                                    onClick={() => { navigate(constants.ENDPOINTS.countSearch); }}>
                                    Cancel
                                 </Button>
                              </td>
                           </tr>
                        </tbody>
                     </Table>
                  </div>
                  : null
               }
            </ServiceThreadSpinner>
         </DesktopContainer >
      </>
   );
}
